<template>
  <div>
    <a-checkbox :checked="allowBrowsingHistory" v-a11y-tab @change="handleChange">{{
      $t('targeting.info.history.checkbox.title')
    }}</a-checkbox>
    <div class="description">
      <p>{{ $t('targeting.info.history.checkbox.short') }}</p>
      <span v-if="!showMore" @click="handleClick" v-a11y-tab>{{ $t('learn.more') }}</span>
      <p v-else>{{ $t('targeting.info.history.checkbox.more') }}</p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SAVE_PRIVATE_INFO } from '@/store/privateInfo/actionTypes';

export default {
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    ...mapGetters(['privateInfo']),
    allowBrowsingHistory() {
      return this.privateInfo.allowBrowsingHistory;
    },
  },
  methods: {
    ...mapActions({
      save: SAVE_PRIVATE_INFO,
    }),
    handleClick() {
      this.showMore = true;
    },
    handleChange() {
      this.save({ allowBrowsingHistory: !this.allowBrowsingHistory });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
@import '~@/assets/styles/fonts.scss';

.description {
  padding-left: 26px;
  p {
    font-size: 14px;
  }
}
span {
  color: $blue;
  cursor: pointer;
}
p {
  max-width: 360px;
  width: 75vw;
  color: $grey;
  padding-bottom: 10px;
}
</style>
